import {
  Component,
  OnInit,
  ViewEncapsulation,
  HostListener,
  EventEmitter,
  Input,
  Output                            } from '@angular/core';
import { LecturesService, IListMeta } from '../providers/lectures.service';
import { VicarService               } from '../providers/vicar.service';
import { CurchService               } from '../providers/church.service';
import { OrganistService            } from '../providers/organist.service';
import { TimeService                } from '../providers/time.service';
import { Observable                 } from 'rxjs/Observable';
import { ITheme, IScripture, IBook  } from '../providers/interfaces';
import { ScripturesService } from '../providers/scriptures.service';
import * as _ from 'lodash';

@Component({
  selector: 'app-scriptures-list',
  templateUrl: './scriptures-list.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./scriptures-list.component.scss']
})
export class ScripturesListComponent implements OnInit {

  public themes$: Observable<ITheme[]>;
  public books$: Observable<IBook[]>;
  public scriptures$: Observable<IScripture[]>;
  public meta$: Observable<IListMeta>;

  public page = 1;
  public pageSize = 10;
  public selectedTheme = null;
  public selectedBook = null;

  constructor(
    private $scriptureSevice: ScripturesService,
  ) {

    this.themes$ = this.$scriptureSevice.selectThemesAllFetch();
    this.books$ = this.$scriptureSevice.selectBooksAllFetch();
    this.scriptures$ = this.$scriptureSevice.selectScripturesAllFetch();
    this.meta$ = this.$scriptureSevice.meta$.asObservable();
    this.$scriptureSevice.dispatchThemesAllFetch();
    this.$scriptureSevice.dispatchBooksAllFetch();
  }

  getNbgLink( scripture: IScripture ) {
    // tslint:disable-next-line:max-line-length
    return `http://www.biblija.net/biblija.cgi?Bible=Bible&m=${encodeURIComponent(scripture.scripture)}&pos=${scripture.verseStart | 0}&set=${scripture.chapterStart | 0}&lang=nl`;
  }

  ngOnInit() {
    console.log( '[SCRIPTURES-LIST]: Init' );
    this.fetch();
  }

  filter() {
    this.page = 1;
    console.log( '[SCRIPTURES-LIST]: Filter' );
    this.fetch();
  }

  fetch() {
    console.log( '[SCRIPTURES-LIST]: Fetch' );
    this.$scriptureSevice.dispatchScripturesAllFetch( this.page, this.pageSize, this.selectedTheme, this.selectedBook );
  }

  paginate( newPage ) {
    console.log( '[SCRIPTURES-LIST]: Paginate', newPage );
    this.page = newPage;
    this.fetch();
  }
}



// WEBPACK FOOTER //
// ./src/app/scriptures-list/scriptures-list.component.ts